import type { NnnRegistrationRow } from '@/api';

export function copyRowForImport(source: NnnRegistrationRow, target: NnnRegistrationRow): NnnRegistrationRow {
  return {
    ...target,
    nnnClassDbRef: source.nnnClassDbRef,
    nnnDiagnosisDbRef: source.nnnDiagnosisDbRef,
    diagnosisNotes: source.diagnosisNotes,
    evaluationDate: source.evaluationDate,
    results: source.results.map(result => ({
      ...result,
      id: null,
      indicators: result.indicators.map(indicator => ({ ...indicator, id: null })),
    })),
    interventions: source.interventions.map(intervention => ({
      ...intervention,
      id: null,
      activities: intervention.activities.map(activity => ({ ...activity, id: null })),
    })),
    instruments: source.instruments.map(instrument => ({ ...instrument, id: null })),
    kenmerken: source.kenmerken.map(kenmerk => ({ ...kenmerk, id: null })),
  };
}
